<section>
  <div class="wrapper px-2 px-sm-5">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <div class="content">
      <div class="title">{{data.title}}</div>
      <br *ngIf="!!data.description">
      <div class="subtitle text-center" *ngIf="!!data.description">{{data.description}}</div>
      <br>
      <form [formGroup]="formMinistryCargos.get('cargos')" *ngIf="!loading">
        <div>
          <p><i>*Recordar que las fechas y horas mostradas en <b>la cita de cargue y descargue</b> se refieren a los
              tiempos estimado diligenciados en la creación del servicio</i></p>
          <p *ngIf="data.type === 'approveCargoModal'">Por favor confirme la fecha y hora de entrega de documentos:</p>
          <br>

          <mat-form-field appearance="outline" class="cursor-pointer" (click)="receipt_date_documents.open()"
            *ngIf="data.type === 'approveCargoModal'">
            <mat-label>Fecha y hora de entrega</mat-label>
            <input matInput readonly [ngxMatDatetimePicker]="receipt_date_documents" [max]="currentDate"
              placeholder="Fecha y hora de entrega" [formControl]="formMinistryCargos.get('receiptDateDocuments')"
              class="cursor-pointer">
            <mat-datepicker-toggle matSuffix [for]="receipt_date_documents"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #receipt_date_documents>
            </ngx-mat-datetime-picker>
            <mat-error *ngIf="formMinistryCargos.get('receiptDateDocuments').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngFor="let _cargo of formMinistryCargosControls; let cargo = index;" [formGroupName]="cargo">

          <div formGroupName="consignment">
            <div *ngFor="let _consignment of getFormMinistryCargoControls(_cargo); let consignment = index;"
              [formGroupName]="consignment" class="d-flex flex-wrap px-0 px-sm-2">
              <div class="dark-bg col-12">
                Remesa {{consignment + 1}}: {{_consignment.get('id').value}} -
                {{_consignment.get('address').value}}
              </div>
              <div class="col-12 alert alert-info position-relative" *ngIf="fingerprintApprovalList[_consignment.get('id').value] 
                && fingerprintApprovalList[_consignment.get('id').value].open" role="alert">
                <i class="fas fa-info-circle fa-lg mr-2"></i>
                Se cargaron los cambios realizados en la última operación por el usuario
                {{fingerprintApprovalList[_consignment.get('id').value].fingerprint?.userName}}
                ({{fingerprintApprovalList[_consignment.get('id').value].fingerprint?.userId}})
                <button type="button" class="btn btn-link text-info p-0 border-0 close-alert-button"
                  (click)="fingerprintApprovalList[_consignment.get('id').value].open = false">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <br>
              <div
                *ngIf="data.manual_consignment_dates && shouldShowSection(_cargo.get('cargoId').value, _consignment.get('id').value, 'upload') && consignment === 0"
                class="col-md-6 mt-3">
                <p class="text-strong text-center">{{shouldShowReasonFields(_cargo.get('cargoId').value,
                  _consignment.get('id').value, 'upload', _cargo.get('requiresMinistryLogisticTimes')?.value) ?
                  'Cargue' : 'Tiempos Logísticos Cargue'}}</p>
                <small class="alert alert-success text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === true">
                  <i class="fas fa-check-circle fa-lg mr-2"></i>Los tiempos logísticos fueron registrados con éxito
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && _consignment.get('upload.rmmErrorMessage')?.value && _consignment.get('upload.rmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('upload.rmmErrorMessage').value}}
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && (!_consignment.get('upload.rmmErrorMessage')?.value || _consignment.get('upload.rmmErrorMessage')?.value.trim() === '')">
                  <i class="fas fa-exclamation-circle fa-lg mr-2"></i>No se pudieron transmitir los tiempos logísticos
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && _consignment.get('upload.rnmmRegistered')?.value === false && _consignment.get('upload.rnmmErrorMessage')?.value && _consignment.get('upload.rnmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('upload.rnmmErrorMessage').value}}
                </small>
                <p class="mb-0"
                  *ngIf="_consignment?.get('upload.estimatedTime')?.value && _consignment?.get('upload.dateLoad')?.value">
                  <span class="text-strong mr-2">Cita cargue:</span>{{ (_consignment?.get('upload.dateLoad')?.value |
                  dateFormat:'only-date')}} - {{ (_consignment?.get('upload.estimatedTime')?.value)}}
                </p>
                <mat-form-field appearance="outline" class="cursor-pointer" (click)="upload_arrival.open()">
                  <mat-label>Llegada cargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly [ngxMatDatetimePicker]="upload_arrival"
                    placeholder="Fecha y hora llegada del cargue" [max]="today"
                    [formControl]="_consignment.get('upload.arrival')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="upload_arrival"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #upload_arrival>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('upload.arrival').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error
                    *ngIf="!_consignment.get('upload.arrival').errors?.required && _consignment.get('upload.arrival').hasError('maxDate')">
                    {{_consignment.get('upload.arrival').errors?.maxDate}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="cursor-pointer" (click)="upload_entry.open()">
                  <mat-label>Entrada cargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly [min]="_consignment?.get('upload.arrival')?.value" [max]="today"
                    [ngxMatDatetimePicker]="upload_entry" placeholder="Fecha y hora entrada del cargue"
                    [formControl]="_consignment.get('upload.entry')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="upload_entry"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #upload_entry>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('upload.entry').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('upload.entry').errors?.required 
                  && _consignment.get('upload.entry').hasError('minDate')">
                    {{_consignment.get('upload.entry').errors?.minDate}}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('upload.entry').errors?.required 
                  && !_consignment.get('upload.entry').hasError('minDate')
                  && _consignment.get('upload.entry').hasError('maxDate')">
                    {{_consignment.get('upload.entry').errors?.maxDate}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="cursor-pointer" (click)="upload_departure.open()">
                  <mat-label>Salida cargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly [min]="_consignment?.get('upload.entry')?.value"
                    [max]="_consignment?.get('download.arrival')?.value ? _consignment?.get('download.arrival')?.value : today"
                    [ngxMatDatetimePicker]="upload_departure" placeholder="Fecha y hora salida del cargue"
                    [formControl]="_consignment.get('upload.departure')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="upload_departure"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #upload_departure>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('upload.departure').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('upload.departure').errors?.required 
                  && _consignment.get('upload.departure').hasError('minDate')">
                    {{_consignment.get('upload.departure').errors?.minDate}}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('upload.departure').errors?.required 
                  && !_consignment.get('upload.departure').hasError('minDate')
                  && _consignment.get('upload.departure').hasError('maxDate')">
                    {{_consignment.get('upload.departure').errors?.maxDate}}
                  </mat-error>
                </mat-form-field>
                <div
                  *ngIf="hasGroupChanged(_consignment.get('id').value, 'upload') && shouldShowReasonFields(_cargo.get('cargoId').value, _consignment.get('id').value, 'upload', _cargo.get('requiresMinistryLogisticTimes')?.value)"
                  class="change-fields my-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Razón del cambio (Cargue)<span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="_consignment.get('upload.reason')">
                      <mat-option *ngFor="let reason of reasonOptions" [value]="reason">
                        {{reason.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Observación (Cargue) <span class="asterisk">*</span></mat-label>
                    <textarea matInput [formControl]="_consignment.get('upload.observation')" rows="2"></textarea>
                    <mat-error
                      *ngIf="(_consignment.get('upload.observation').touched || _consignment.get('upload.observation').dirty) && (!_consignment.get('upload.observation').value || _consignment.get('upload.observation').value.trim() === '')">
                      {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <p>
                  <span class="text-strong mr-2">Tiempo pactado:</span>
                  {{_consignment?.get('upload.hourPact')?.value ? _consignment?.get('upload.hourPact')?.value > 1 ?
                  _consignment?.get('upload.hourPact')?.value + ' horas ' : '1 hora ' : ''}}
                  {{_consignment?.get('upload.minutePact')?.value ? _consignment?.get('upload.minutePact')?.value > 1 ?
                  _consignment?.get('upload.minutePact')?.value + ' minutos' : '1 minuto' : ''}}
                </p>
                <p>
                  <span class="text-strong mr-2">Tiempo ejecutado:</span>
                  {{getExecutedTime(_consignment, 'upload')}}
                </p>
                <p class="w-100 text-bold text-center alert alert-warning" role="alert"
                  *ngIf="showAlertTimePact(_consignment, 'upload')">
                  {{showAlertTimePact(_consignment, 'upload')}}
                </p>
              </div>
              <div class="col-md-6 mt-3" [ngClass]="{'offset-md-6': consignment !== 0}"
                *ngIf="data.manual_consignment_dates && shouldShowSection(_cargo.get('cargoId').value, _consignment.get('id').value, 'download')">
                <p class="text-strong text-center">{{shouldShowReasonFields(_cargo.get('cargoId').value,
                  _consignment.get('id').value, 'download', _cargo.get('requiresMinistryLogisticTimes')?.value) ?
                  'Descargue' : 'Tiempos Logísticos Descargue'}}</p>
                <small class="alert alert-success text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === true">
                  <i class="fas fa-check-circle fa-lg mr-2"></i>Los tiempos logísticos fueron registrados con éxito
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && _consignment.get('download.rmmErrorMessage')?.value && _consignment.get('download.rmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('download.rmmErrorMessage').value}}
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && (!_consignment.get('download.rmmErrorMessage')?.value || _consignment.get('download.rmmErrorMessage')?.value.trim() === '')">
                  <i class="fas fa-exclamation-circle fa-lg mr-2"></i>No se pudieron transmitir los tiempos logísticos
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && _consignment.get('download.rnmmRegistered')?.value === false && _consignment.get('download.rnmmErrorMessage')?.value && _consignment.get('download.rnmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('download.rnmmErrorMessage').value}}
                </small>
                <p class="mb-0"
                  *ngIf="_consignment?.get('download.estimatedTime')?.value && _consignment?.get('download.dateDownload')?.value">
                  <span class="text-strong mr-2">Cita descargue:</span>{{
                  (_consignment?.get('download.dateDownload')?.value |
                  dateFormat:'only-date')}} - {{ (_consignment?.get('download.estimatedTime')?.value)}}
                </p>

                <mat-form-field appearance="outline" class="cursor-pointer" (click)="download_arrival.open()">
                  <mat-label>Llegada descargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly [max]="today" [ngxMatDatetimePicker]="download_arrival"
                    placeholder="Fecha y hora llegada del descargue"
                    [formControl]="_consignment.get('download.arrival')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="download_arrival"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #download_arrival>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('download.arrival').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.arrival').errors?.required 
                  && _consignment.get('download.arrival').hasError('minDate')">
                    {{_consignment.get('download.arrival').errors?.minDate}}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.arrival').errors?.required 
                  && !_consignment.get('download.arrival').hasError('minDate')
                  && _consignment.get('download.arrival').hasError('maxDate')">
                    {{_consignment.get('download.arrival').errors?.maxDate}}
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="cursor-pointer" (click)="download_entry.open()">
                  <mat-label>Entrada descargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly [min]="getMinDownloadEntry(_consignment?.get('download.arrival')?.value)"
                    [max]="today" [ngxMatDatetimePicker]="download_entry" placeholder="Fecha y hora salida del cargue"
                    [formControl]="_consignment.get('download.entry')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="download_entry"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #download_entry>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('download.entry').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.entry').errors?.required 
                  && _consignment.get('download.entry').hasError('minDate')">
                    {{_consignment.get('download.entry').errors?.minDate}}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.entry').errors?.required 
                  && !_consignment.get('download.entry').hasError('minDate')
                  && _consignment.get('download.entry').hasError('maxDate')">
                    {{_consignment.get('download.entry').errors?.maxDate}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="cursor-pointer" (click)="download_departure.open()">
                  <mat-label>Salida descargue<span class="asterisk">*</span></mat-label>
                  <input matInput readonly
                    [min]="formatMinDateDownloadDeparture(_consignment?.get('download.entry')?.value, _consignment.get('download.minutePact')?.value, _consignment.get('download.timePact')?.value)"
                    [ngxMatDatetimePicker]="download_departure" placeholder="Fecha y hora salida del cargue"
                    [max]="today" [formControl]="_consignment.get('download.departure')" class="cursor-pointer">
                  <mat-datepicker-toggle matSuffix [for]="download_departure"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #download_departure>
                  </ngx-mat-datetime-picker>
                  <mat-error *ngIf="_consignment.get('download.departure').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.departure').errors?.required 
                  && _consignment.get('download.departure').hasError('minDate')">
                    {{_consignment.get('download.departure').errors?.minDate}}
                  </mat-error>

                  <mat-error *ngIf="!_consignment.get('download.departure').errors?.required
                  && !_consignment.get('download.departure').hasError('minDate')
                  && _consignment.get('download.departure').hasError('maxDate')">
                    {{_consignment.get('download.departure').errors?.maxDate}}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.departure').errors?.required
                  && !_consignment.get('download.departure').hasError('minDate')
                  && !_consignment.get('download.departure').hasError('maxDate')
                  && _consignment.get('download.departure').hasError('matDatetimePickerMin')">
                    Debe ser mayor a {{ _consignment.get('download.departure').errors?.matDatetimePickerMin?.min | dateFormat:'date-time-full-24' }}
                  </mat-error>
                  <mat-error *ngIf="!_consignment.get('download.departure').errors?.required
                  && !_consignment.get('download.departure').hasError('minDate')
                  && !_consignment.get('download.departure').hasError('maxDate')
                  && !_consignment.get('download.departure').hasError('matDatetimePickerMin')
                  && _consignment.get('download.departure').hasError('matDatetimePickerMax')">
                    Debe ser menor a {{ _consignment.get('download.departure').errors?.matDatetimePickerMax?.max | dateFormat:'date-time-full-24' }}
                  </mat-error>
                </mat-form-field>
                <div
                  *ngIf="hasGroupChanged(_consignment.get('id').value, 'download') && shouldShowReasonFields(_cargo.get('cargoId').value, _consignment.get('id').value, 'download', _cargo.get('requiresMinistryLogisticTimes')?.value)"
                  class="change-fields my-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Razón del cambio (Descargue)<span class="asterisk">*</span></mat-label>
                    <mat-select [formControl]="_consignment.get('download.reason')">
                      <mat-option *ngFor="let reason of reasonOptions" [value]="reason">
                        {{reason.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Observación (Descargue) <span class="asterisk">*</span></mat-label>
                    <textarea matInput [formControl]="_consignment.get('download.observation')" rows="2"></textarea>
                    <mat-error
                      *ngIf="(_consignment.get('download.observation').touched || _consignment.get('download.observation').dirty) && (!_consignment.get('download.observation').value || _consignment.get('download.observation').value.trim() === '')">
                      {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <p>
                  <span class="text-strong mr-2">Tiempo pactado:</span>
                  {{_consignment?.get('download.hourPact')?.value ? _consignment?.get('download.hourPact')?.value > 1 ?
                  _consignment?.get('download.hourPact')?.value + ' horas ' : '1 hora ' : ''}}
                  {{_consignment?.get('download.minutePact')?.value ? _consignment?.get('download.minutePact')?.value >
                  1 ? _consignment?.get('download.minutePact')?.value + ' minutos' : '1 minuto' : ''}}
                </p>
                <p>
                  <span class="text-strong mr-2">Tiempo ejecutado:</span>
                  {{getExecutedTime(_consignment, 'download')}}
                </p>
                <p class="w-100 text-bold text-center alert alert-warning" role="alert"
                  *ngIf="showAlertTimePact(_consignment, 'download')">
                  {{showAlertTimePact(_consignment, 'download')}}
                </p>
              </div>

              <div class="col-md-6 mt-3"
                *ngIf="shouldShowSection(_cargo.get('cargoId').value, _consignment.get('id').value, 'upload') && !data.manual_consignment_dates && consignment === 0">
                <p class="text-strong text-center">{{shouldShowReasonFields(_cargo.get('cargoId').value,
                  _consignment.get('id').value, 'upload', _cargo.get('requiresMinistryLogisticTimes')?.value) ?
                  'Cargue' : 'Tiempos Logísticos Cargue'}}</p>
                <small class="alert alert-success text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === true">
                  <i class="fas fa-check-circle fa-lg mr-2"></i>Los tiempos logísticos fueron registrados con éxito
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && _consignment.get('upload.rmmErrorMessage')?.value && _consignment.get('upload.rmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('upload.rmmErrorMessage').value}}
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && (!_consignment.get('upload.rmmErrorMessage')?.value || _consignment.get('upload.rmmErrorMessage')?.value.trim() === '')">
                  <i class="fas fa-exclamation-circle fa-lg mr-2"></i>No se pudieron transmitir los tiempos logísticos
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('upload.rmmRegistered')?.value === false && _consignment.get('upload.rnmmRegistered')?.value === false && _consignment.get('upload.rnmmErrorMessage')?.value && _consignment.get('upload.rnmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('upload.rnmmErrorMessage').value}}
                </small>
                <p
                  *ngIf="_consignment?.get('upload.estimatedTime')?.value && _consignment?.get('upload.dateLoad')?.value">
                  <span class="text-strong mr-2">Cita cargue:</span>{{ (_consignment?.get('upload.dateLoad')?.value |
                  dateFormat:'only-date')}} - {{ (_consignment?.get('upload.estimatedTime')?.value)}}
                </p>
                <p class="mb-0 mt-2">
                  <label class="text-strong">
                    Llegada cargue
                    <span *ngIf="_consignment.get('upload.startDateSource')?.value">
                      ({{_consignment.get('upload.startDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  <span>{{_consignment.get('upload.arrival').value | dateFormat:'date-time-full-24'}}</span>
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert" *ngIf="_consignment.get('upload.arrival').errors?.required || 
                  _consignment.get('upload.arrival').hasError('maxDate')">
                  {{_consignment.get('upload.arrival').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('upload.arrival').errors?.maxDate}}
                </small>
                <p class="mb-0 mt-2">
                  <label class="text-strong">
                    Entrada cargue
                    <span *ngIf="_consignment.get('upload.startDateSource')?.value">
                      ({{_consignment.get('upload.startDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  <span>{{_consignment.get('upload.entry').value | dateFormat:'date-time-full-24'}}</span>
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_consignment.get('upload.entry').errors?.required || 
                  _consignment.get('upload.entry').hasError('minDate') || _consignment.get('upload.entry').hasError('maxDate')">
                  {{_consignment.get('upload.entry').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('upload.entry').hasError('minDate')
                  ? _consignment.get('upload.entry').errors?.minDate
                  : _consignment.get('upload.entry').errors?.maxDate}}
                </small>
                <p class="mb-0 mt-2">
                  <label class="text-strong">
                    Salida cargue
                    <span *ngIf="_consignment.get('upload.endDateSource')?.value">
                      ({{_consignment.get('upload.endDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  <span>{{_consignment.get('upload.departure').value | dateFormat:'date-time-full-24'}}</span>
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_consignment.get('upload.departure').errors?.required || 
                  _consignment.get('upload.departure').hasError('minDate') || _consignment.get('upload.departure').hasError('maxDate')">
                  {{_consignment.get('upload.departure').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('upload.departure').hasError('minDate')
                  ? _consignment.get('upload.departure').errors?.minDate
                  : _consignment.get('upload.departure').errors?.maxDate}}
                </small>
                <p class="mt-2">
                  <span class="text-strong">Tiempo pactado:</span>
                  &nbsp;
                  {{_consignment?.get('upload.hourPact')?.value ? _consignment?.get('upload.hourPact')?.value > 1 ?
                  _consignment?.get('upload.hourPact')?.value + ' horas ' : '1 hora ' : ''}}
                  {{_consignment?.get('upload.minutePact')?.value ? _consignment?.get('upload.minutePact')?.value > 1
                  ?
                  _consignment?.get('upload.minutePact')?.value + ' minutos' : '1 minuto' : ''}}
                </p>
                <p>
                  <span class="text-strong">Tiempo ejecutado:</span>
                  &nbsp;
                  {{getExecutedTime(_consignment, 'upload')}}
                </p>
                <p class="w-100 text-bold text-center alert alert-warning" role="alert"
                  *ngIf="showAlertTimePact(_consignment, 'upload')">
                  {{showAlertTimePact(_consignment, 'upload')}}
                </p>
              </div>
              <div class="col-md-6 mt-3" [ngClass]="{'offset-md-6': consignment !== 0}"
                *ngIf="shouldShowSection(_cargo.get('cargoId').value, _consignment.get('id').value, 'download') && !data.manual_consignment_dates">
                <p class="text-strong text-center">{{shouldShowReasonFields(_cargo.get('cargoId').value,
                  _consignment.get('id').value, 'download', _cargo.get('requiresMinistryLogisticTimes')?.value) ?
                  'Descargue' : 'Tiempos Logísticos Descargue'}}</p>
                <small class="alert alert-success text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === true">
                  <i class="fas fa-check-circle fa-lg mr-2"></i>Los tiempos logísticos fueron registrados con éxito
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && _consignment.get('download.rmmErrorMessage')?.value && _consignment.get('download.rmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('download.rmmErrorMessage').value}}
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && (!_consignment.get('download.rmmErrorMessage')?.value || _consignment.get('download.rmmErrorMessage')?.value.trim() === '')">
                  <i class="fas fa-exclamation-circle fa-lg mr-2"></i>No se pudieron transmitir los tiempos logísticos
                </small>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_cargo.get('requiresMinistryLogisticTimes')?.value === true && _consignment.get('download.rmmRegistered')?.value === false && _consignment.get('download.rnmmRegistered')?.value === false && _consignment.get('download.rnmmErrorMessage')?.value && _consignment.get('download.rnmmErrorMessage')?.value.trim() !== ''">
                  <i
                    class="fas fa-exclamation-circle fa-lg mr-2"></i>{{_consignment.get('download.rnmmErrorMessage').value}}
                </small>
                <p
                  *ngIf="_consignment?.get('download.estimatedTime')?.value && _consignment?.get('download.dateDownload')?.value">
                  <span class="text-strong mr-2">Cita descargue:</span>{{
                  (_consignment?.get('download.dateDownload')?.value |
                  dateFormat:'only-date')}} - {{ (_consignment?.get('download.estimatedTime')?.value)}}
                </p>
                <p class="mb-0 mt-2">
                  <label class="text-strong mr-2">
                    Llegada descargue
                    <span *ngIf="_consignment.get('download.startDateSource')?.value">
                      ({{_consignment.get('download.startDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  {{_consignment?.get('download.arrival')?.value | dateFormat:'date-time-full-24'}}
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_consignment.get('download.arrival').errors?.required || 
                _consignment.get('download.arrival').hasError('minDate') || _consignment.get('download.arrival').hasError('maxDate')">
                  {{_consignment.get('download.arrival').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('download.arrival').hasError('minDate')
                  ? _consignment.get('download.arrival').errors?.minDate
                  : _consignment.get('download.arrival').errors?.maxDate}}
                </small>
                <p class="mb-0 mt-2">
                  <label class="text-strong">
                    Entrada descargue
                    <span *ngIf="_consignment.get('download.startDateSource')?.value">
                      ({{_consignment.get('download.startDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  <span>{{_consignment.get('download.entry').value | dateFormat:'date-time-full-24'}}</span>
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_consignment.get('download.entry').errors?.required || 
                  _consignment.get('download.entry').hasError('minDate') || _consignment.get('download.entry').hasError('maxDate')">
                  {{_consignment.get('download.entry').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('download.entry').hasError('minDate')
                  ? _consignment.get('download.entry').errors?.minDate
                  : _consignment.get('download.entry').errors?.maxDate}}
                </small>
                <p class="mb-0 mt-2">
                  <label class="text-strong">Salida descargue
                    <span *ngIf="_consignment.get('download.endDateSource')?.value">
                      ({{_consignment.get('download.endDateSource')?.value === 'manual' ? 'Manual' : 'GPS'}})
                    </span>
                    :</label>
                  &nbsp;
                  <span>{{_consignment.get('download.departure').value | dateFormat:'date-time-full-24'}}</span>
                </p>
                <small class="alert alert-danger text-bold px-2 my-1 d-block" role="alert"
                  *ngIf="_consignment.get('download.departure').errors?.required || 
                  _consignment.get('download.departure').hasError('minDate') || _consignment.get('download.departure').hasError('maxDate')">
                  {{_consignment.get('download.departure').errors?.required
                  ? utils.giveMessageError('MANDATORY_FIELD')
                  : _consignment.get('download.departure').hasError('minDate')
                  ? _consignment.get('download.departure').errors?.minDate
                  : _consignment.get('download.departure').errors?.maxDate}}
                </small>
                <p class="mt-2">
                  <span class="text-strong mr-2">Tiempo pactado:</span>
                  {{_consignment?.get('download.hourPact')?.value ? _consignment?.get('download.hourPact')?.value > 1
                  ?
                  _consignment?.get('download.hourPact')?.value + ' horas ' : '1 hora ' : ''}}
                  {{_consignment?.get('download.minutePact')?.value ? _consignment?.get('download.minutePact')?.value
                  >
                  1 ? _consignment?.get('download.minutePact')?.value + ' minutos' : '1 minuto' : ''}}
                </p>
                <p>
                  <span class="text-strong mr-2">Tiempo ejecutado:</span>
                  {{getExecutedTime(_consignment, 'download')}}
                </p>
                <p class="w-100 text-bold text-center alert alert-warning" role="alert"
                  *ngIf="showAlertTimePact(_consignment, 'download')">
                  {{showAlertTimePact(_consignment, 'download')}}
                </p>
              </div>

              <div class="amount col-12">
                <label class="text-strong">Cantidad entregada:</label>
                &nbsp;
                <mat-form-field style="width: 100px;">
                  <input formControlName="amountDelivered" name="amountDelivered" matInput type="number"
                    style="padding-right: 0 !important;" [disabled]="!data.manual_consignment_dates"
                    [readonly]="!data.manual_consignment_dates">
                  <mat-error *ngIf="_consignment.get('amountDelivered').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="button-container mt-2 justify-content-end">
      <button mat-raised-button color="accent" class="primary-secondary mx-1" type="button"
        (click)="dialogRef.close(false)">Cancelar</button>
      <button *ngIf="permissionToSave" mat-raised-button color="accent" (click)="approve()" class="mx-1"
        [ngClass]="{'disabled-btn': !!disabledReason}" [matTooltip]="disabledReason"
        matTooltipClass="tooltip__warning">
        {{data.type === 'logisticTimesModal' ? 'Guardar cambios' : 'Confirmar'}}
      </button>
      <button permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.editLogisticTimes"
        mat-raised-button color="accent" (click)="goToEditableVisual()" class="mx-1"
        *ngIf="!data?.manual_consignment_dates && cargosRNDC?.length">Editar</button>
      <button permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.editLogisticTimes"
        mat-raised-button color="accent" (click)="goToEditableVisual(true)" class="mx-1"
        *ngIf="!data?.manual_consignment_dates && cargosRNDC?.length && !onlyReemit && data.type === 'logisticTimesModal'">Transmitir</button>
    </div>
  </div>
</section>